import React from 'react';
import PropTypes from 'prop-types';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import MessagingContextMenu from 'Components/UI/ContextMenu/MessagingContextMenu';

const RichTextDisplayWithMessageContextMenu = ({
  content,
}) => {
  return (
    <MessagingContextMenu>
      <RichTextDisplay
        content={content}
      />
    </MessagingContextMenu>
  );
};

RichTextDisplayWithMessageContextMenu.defaultProps = {
};

RichTextDisplayWithMessageContextMenu.propTypes = {
  content: PropTypes.string.isRequired,
};

export default RichTextDisplayWithMessageContextMenu;
